//1.导入Vue和VueRouter的包
import Vue from 'vue'
import VueRouter from 'vue-router'
import Cookies from 'js-cookie'
import index from '@/views/index/home.vue'
import receivingAddress from '@/views/index/receiving-address.vue'
import Invoice from '@/views/index/Invoice.vue'
import payment from '@/views/index/payment.vue'
import detail from '@/views/detail/detail.vue'
import personCenter from '@/views/person/index.vue'

//2.调用Vue.use()函数，把VueRouter安装为Vue的插件
Vue.use(VueRouter)
const routes = [{
    path: '*',
    redirect: '/index' //重定向
},
{
    path: '/index',
    name: 'index',
    //组件已经导入，直接写组件名
    component: index, //路由名字
    children: [
        //子路由
    ]
},
{
    path: '/receiving-address',
    name: 'receiving-address',
    //组件已经导入，直接写组件名
    component: receivingAddress
},
{
    path: '/Invoice',
    name: 'Invoice',
    //组件已经导入，直接写组件名
    component: Invoice
},
{
    path: '/payment',
    name: 'payment',
    //组件已经导入，直接写组件名
    component: payment,
},
{
    path: '/person',
    component: () => import('@/views/person/index.vue'),
    children: [
        { path: 'info', component: () => import('@/views/person/info.vue') },
        { path: 'order', component: () => import('@/views/person/order.vue') },
        { path: 'order/detail', component: () => import('@/views/person/orderDetail.vue') },
        { path: 'address', component: () => import('@/views/person/address.vue') },
        { path: 'invoice', component: () => import('@/views/person/invoice.vue') },
    ]
},


]
//3.创建路由的实例对象
const router = new VueRouter({
    routes
})

// 添加全局前置守卫
router.beforeEach((to, from, next) => {
    const token = Cookies.get('Authorization')
    if (to.path !== '/index' && !token) {
        next('/index')
    } else {
        next()
    }
})

//4.向外共享路由的实例对象
export default router